import { render } from "./Playtimes.vue?vue&type=template&id=f1a65434"
import script from "./Playtimes.vue?vue&type=script&lang=js"
export * from "./Playtimes.vue?vue&type=script&lang=js"

import "./Playtimes.vue?vue&type=style&index=0&id=f1a65434&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__